import { Exercise } from '@entities/exercise'
import { MuscleService } from '@entities/muscle'
import { getMediaUrl } from '@shared/helpers/getMediaUrl'
import { ExerciseParams } from '../types'

export function buildExerciseParamsFromExercise(
	exercise: Exercise,
	index: number,
): ExerciseParams {
	const muscleGroups = MuscleService.getMuscleLabelsParentsInfo(
		exercise.muscle_group_codes,
	)
	const baseParams = {
		exerciseName: exercise.name,
		exercise_id: exercise.id_exercise,
		order: index + 1,
		imageUrl: getMediaUrl(exercise.media.icon),
		primaryMuscle: muscleGroups[0]?.name,
		secondaryMuscles: muscleGroups.slice(1, 4).map((muscle) => muscle.name),
	}

	if (exercise.type === 'cardio') {
		return {
			...baseParams,
			type: 'cardio',
			duration: exercise.default_duration ?? undefined,
			rest_time: exercise.default_rest_time ?? undefined,
		}
	}

	return {
		...baseParams,
		type: 'strength',
		sets: exercise.default_sets ?? undefined,
		reps: exercise.default_reps ?? undefined,
		duration: exercise.default_duration ?? undefined,
		rest_time: exercise.default_rest_time ?? undefined,
	}
}
